import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppraisalService } from '../../services/appraisal.service';
import { AuthService } from '../../services/auth.service';
import { useToast } from '../../context/ToastContext';
import { IReviewSummary } from '../../interfaces/appraisal.interface';
import ReviewTable from './ReviewTable';

/** Reviews where the signed-in user is the reviewer. Everyone sees the menu; most get the empty state. */
const ReviewsToWrite: React.FC = () => {
    const toast = useToast();
    const { t } = useTranslation('appraisal');
    const institutionId = AuthService.getSelectedInstitution()!;
    const [reviews, setReviews] = useState<IReviewSummary[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                setReviews(await AppraisalService.reviewsToWrite(institutionId));
            } catch (err) {
                toast.showApiError(err, t('errors.loadReviews'));
            } finally {
                setLoading(false);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [institutionId]);

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>{t('toWrite.title')}</Typography>
            <ReviewTable reviews={reviews} loading={loading} mode="toWrite" emptyText={t('toWrite.empty')} />
        </Box>
    );
};

export default ReviewsToWrite;
